import api from "../utils/api";
import { storeOptionalUrl } from "../utils/auth/navigation";
import { get as getNotifications } from "./notification";
import { mine as getPermissions } from "./permissions";
import { pack } from "./alert";

import {
  AUTH_ERROR,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_LOADED,
  PASSWORD_CHANGE
} from "./types";

export const permitted = (name) => async (dispatch) => {
  try {
    const res_permitted = await api.get(`/users/me/permitted/n/${name}`);
    return res_permitted?.status === 200;
  } catch (error) {
    return false;
  }
}

export const get = () => async (dispatch) => {
  try {
    const res = await api.get("/users/me");
    const res_permitted = await api.get("/users/me/permitted/n/CAN.LOGIN");
    if (res_permitted.status !== 200) throw new Error(res_permitted?.data?.msg);
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
    dispatch(getNotifications());
    dispatch(getPermissions());
    return res.data;
    
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const tokenize = (instance, token, url) => async (dispatch) => {
  try {
    localStorage.setItem("instance", instance);
    localStorage.setItem("token", token);
    localStorage.setItem("api", url);

    const res = await api.get("settings/p/c/FrontEnd");
    
    localStorage.setItem("title", res.data["SITE_TITLE"]);
    storeOptionalUrl("loginUrl", res.data["LOGINURL"]);
    localStorage.setItem("smallLogo", res.data["SMALL_LOGO"]);
    localStorage.setItem("features", res.data["FEATURES"]);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token, instance },
    });

    dispatch(get());

    return true;
  } catch (error) {
    console.log(error);
    dispatch({
      type: LOGIN_FAILED,
    });
  }
  return false;
}

export const changeMyPassword = ({original, newPassword}) => async (dispatch) => {
  try {
    const res = await api.post(`/users/me/password`, { original, password: newPassword });

    dispatch({
      type: PASSWORD_CHANGE,
      payload: res.data,
    });

    return { success: true, data: res.data };
  } catch (err) {
    const payload = {
      msg: err?.response?.data?.msg || err?.response?.statusText || "Password change failed",
      status: err?.response?.status || 500,
    };

    dispatch({
      type: AUTH_ERROR,
      payload,
    });

    return { success: false, error: payload };
  }
};

export const reset = (email) => async (dispatch) => {
  try {
    const res = await api.post(`/auth/reset`, { email });
    dispatch(pack(["Password reset email sent"], "success"));
    return res.data;
  } catch (err) {
    const message = err?.response?.data?.error?.message || err?.response?.data?.message || err?.response?.statusText || "Password reset failed";
    dispatch(pack([message], "error"));
    return {
      success: false,
      error: {
        message,
        status: err?.response?.status || 500
      }
    };
  }
}


export const logout = () => async (dispatch) => {
    dispatch({ type: LOGOUT });
};

